import { createContext, FC, useEffect, useState } from "react"

import { PageLoader } from "@/components/_Shared/PageLoader"
import { APP_VERSION_KEY } from "@/constants/localStorageKeys"
import { getVersion } from "@/http/version"

interface IAppVersion {
  app: string;
  api: string | null;
}

const AppVersionContext = createContext<IAppVersion | undefined>(undefined)

export const AppVersionProvider: FC<any> = ({ children }) => {

  const [version, setVersion] = useState<IAppVersion | undefined>(undefined)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const CURRENT_APP_VERSION = process.env.REACT_APP_VERSION ?? ""

  useEffect(() => {

    const storedFromLocal = localStorage.getItem(APP_VERSION_KEY)
    const storedVersion = storedFromLocal ? JSON.parse(storedFromLocal) as IAppVersion : null

    getVersion()
      .then(resp => {
        const apiVersion = resp
        const currentVersion: IAppVersion = { app: CURRENT_APP_VERSION, api: apiVersion ?? null }
        setVersion(currentVersion)

        if (!storedVersion || (storedVersion
          && (storedVersion.api !== currentVersion.api || storedVersion.app !== currentVersion.app))
        ) {
          clearLocalStorageTableSettings()
        }

        localStorage.setItem(APP_VERSION_KEY, JSON.stringify(currentVersion))
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  function clearLocalStorageTableSettings() {
    let keysToRemove = []
    const mask = "_KEY"

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (key && key.endsWith(mask)) {
        keysToRemove.push(key)
      }
    }

    for (const key of keysToRemove) {
      localStorage.removeItem(key)
    }
  }

  if (isLoading) return (
    <PageLoader />
  )

  return (
    <AppVersionContext.Provider value={version}>
      {children}
    </AppVersionContext.Provider>
  )
}
